module.exports = __webpack_public_path__ + "img/brandguide_nomenclature.515ab6d3.jpg";